<template>
  <div class="page">
    <Item
      :desc="info.deposit_text"
      :status="info.deposit_status"
      v-for="(item, index) in list"
      :key="index"
      :item="item"
      :type="index + 1"
      @Refresh="CupGetPlanList"
    />
    <!-- <Item :type="2" /> -->
    <Btn title="继续订购" v-if="info.allow_add" style="margin-top: .24rem" @click="GOModelChoice" />
  </div>
</template>

<script>
  import Item from './components/Item'
  export default {
    data () {
      return {
        info: {},
        list: []
      }
    },
    components: {
      Item
    },
    methods: {
      CupGetPlanList () {
        this.$Get('Common.CupGetPlanList', {
          cup_id: this.$route.query.id
        }).then(res => {
          this.info = res.data
          this.list = res.data.planList
        })
      },
      GOModelChoice () {
        this.$ShowConfirm(this.info.plan_text, {
          title: '温馨提示',
          showCancel: false,
          messageAlign: 'left',
          confirmText: '我知道了'
        }).then(() => {
          this.$nav('Common.ModelChoice', { id: this.$route.query.id })
        })
      }
    },
    created () {
      this.CupGetPlanList()
    }
  }
</script>

<style lang="less" scoped>
  .page {
    min-height: 100vh;
    .bg(#fafafa);
    box-sizing: border-box;
    .p(.3rem .24rem);
  }
</style>
